import { Group } from '@visx/group'

import { getReconciliationSpecOperationFromDate } from '../../uiModels/reconciliationSpecOperations/helpers'
import type { IndexedReconciliationSpecOperationWithMetaData } from '../../uiModels/reconciliationSpecOperations/types'
import { NO_DATE_SYMBOL } from '../../util/constants'
import type { ChildProps } from '../versionedTimeline/VersionedArrowsGroup'
import { VersionedTimeline } from '../versionedTimeline/VersionedTimeline'
import { ReconciliationSpecVersionsForDate } from './ReconciliationSpecVersionsForDate'

/**
 * Timeline line holding every version of the reconciliation spec in scope. Spec versions
 * are only created by uploading an Excel file, so no draft can be created from the line
 * itself.
 */
export const ReconciliationSpecVersionsLine = ({
  versions,
  lineStartDate,
  lineEndDate,
  lineLength,
}: ChildProps<IndexedReconciliationSpecOperationWithMetaData>) => (
  <Group>
    <VersionedTimeline
      lengthInPixels={lineLength}
      startDate={lineStartDate}
      endDate={lineEndDate}
      versions={versions}
      versionDate={(version) =>
        getReconciliationSpecOperationFromDate(version.internalOperation) ??
        NO_DATE_SYMBOL
      }
      renderDateVersions={({ date, versions, dateToPixel }) => (
        <ReconciliationSpecVersionsForDate
          key={date.toString()}
          versions={versions}
          dateToPixel={dateToPixel}
          earliestVersionDate={lineStartDate}
        />
      )}
    />
  </Group>
)
